import { Route } from '@angular/router';
import { authGuard, noAuthGuard } from '@coworkrz/auth/data-access';
import { SignInComponent } from '@coworkrz/auth/sign-in';
import { BaseAdminLayoutComponent } from '@coworkrz/shared/admin-layout';
import { AuthLayoutComponent } from '@coworkrz/shared/layout';
import { appResolver } from './app.resolver';

export const appRoutes: Route[] = [
  {
    path: '',
    component: BaseAdminLayoutComponent,
    resolve: [appResolver],
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'sessions',
        loadComponent: () =>
          import('@coworkrz/sessions/feature-list').then(
            (c) => c.SessionListComponent
          ),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkrz/sessions/feature-details').then(
                (c) => c.SessionDetailsComponent
              ),
          },
        ],
      },

      {
        path: 'members',
        loadComponent: () =>
          import('@coworkrz/members/feature-list').then(
            (c) => c.MemberListComponent
          ),
        children: [
          {
            path: 'new',
            loadComponent: () =>
              import('@coworkrz/members/feature-create').then(
                (c) => c.MemberCreateComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkrz/members/feature-details').then(
                (c) => c.MemberDetailsComponent
              ),
          },
        ],
      },
      {
        path: 'cart',
        loadComponent: () =>
          import('@coworkrz/products/product-cart-list').then(
            (c) => c.ProductCartListComponent
          ),
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('@coworkrz/invoices/feature-list').then(
            (c) => c.InvoiceListComponent
          ),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkrz/invoices/feature-details').then(
                (c) => c.InvoiceDetailsComponent
              ),
          },
        ],
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@coworkrz/home').then((c) => c.HomeComponent),
      },
      {
        path: 'teams',
        loadComponent: () =>
          import('@coworkrz/teams/feature-list').then(
            (c) => c.TeamListComponent
          ),
        children: [
          {
            path: 'new',
            loadComponent: () =>
              import('@coworkrz/teams/feature-create').then(
                (c) => c.TeamCreateComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkrz/teams/feature-details').then(
                (c) => c.TeamDetailsComponent
              ),
          },
          {
            path: ':id/members',
            loadComponent: () =>
              import('@coworkrz/teams/feature-details').then(
                (c) => c.TeamMembersComponent
              ),
          },
        ],
      },
      {
        path: 'products',
        loadComponent: () =>
          import('@coworkrz/products/feature-list').then(
            (p) => p.ProductListComponent
          ),
        children: [
          {
            path: 'new',
            loadComponent: () =>
              import('@coworkrz/products/feature-create').then(
                (c) => c.FeatureCreateComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkz/products/feature-details').then(
                (p) => p.ProductDetailsComponent
              ),
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('@coworkrz/products/feature-list').then(
                    (c) => c.PricesListComponent
                  ),
              },
            ],
          },
        ],
      },
      {
        path: 'reservations',
        loadComponent: () =>
          import('@coworkrz/reservations/feature-list').then(
            (c) => c.ReservationListComponent
          ),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('@coworkrz/reservations/feature-details').then(
                (c) => c.ReservationDetailsComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [noAuthGuard],
    children: [
      {
        path: 'auth/sign-in',
        component: SignInComponent,
      },
    ],
  },
];
